<div class="face-detector-container">
  <app-face-compare-loader
    [isLoading]="currentLoadingState.isLoading"
    [loadingText]="currentLoadingState.loadingText">
  </app-face-compare-loader>

  <div class="normal-view-container">
    <div class="images-comparison">
      <div class="image-section">
        <div class="image-header">
          <h4 class="image-title">{{ selectedImages[0]?.name || 'Image 1' }}</h4>
        </div>

        <div class="image-container"
            (wheel)="onWheel($event, 1)">
          <div class="image-wrapper"
              [style.transform]="'scale(' + image1Zoom + ') translate(' + image1PanX + 'px, ' + image1PanY + 'px)'"
              (mousedown)="startPan($event, 1)"
              (mousemove)="onPan($event, 1)"
              (mouseup)="endPan(1)"
              (mouseleave)="endPan(1)">
            <img
              [src]="getImageWithBoundingBoxes(0)"
              [alt]="selectedImages[0]?.name"
              class="detected-image"
              #image1>
          </div>
        </div>

        <div class="image-controls">
          <div class="zoom-controls">
            <label class="zoom-label">Zoom</label>
            <input
              type="range"
              class="zoom-slider"
              min="0.5"
              max="10"
              step="0.1"
              value="1"
              [(ngModel)]="image1Zoom"
              (input)="onZoomChange(1, $event)">
            <span class="zoom-value">{{ image1Zoom }}x</span>
          </div>
          <div class="button-group">
            <!-- Face enhance temporarily disabled
            <button class="enhance-btn" (click)="onEnhance(1)">
              Enhance
            </button>
            -->
            <button class="reset-btn" (click)="onReset(1)">
              Reset
            </button>
          </div>
        </div>
      </div>

      <div class="image-section">
        <div class="image-header">
          <h4 class="image-title">{{ selectedImages[1]?.name || 'Image 2' }}</h4>
        </div>

        <div class="image-container"
            (wheel)="onWheel($event, 2)">
          <div class="image-wrapper"
              [style.transform]="'scale(' + image2Zoom + ') translate(' + image2PanX + 'px, ' + image2PanY + 'px)'"
              (mousedown)="startPan($event, 2)"
              (mousemove)="onPan($event, 2)"
              (mouseup)="endPan(2)"
              (mouseleave)="endPan(2)">
            <img
              [src]="getImageWithBoundingBoxes(1)"
              [alt]="selectedImages[1]?.name"
              class="detected-image"
              #image2>
          </div>
        </div>

        <div class="image-controls">
          <div class="zoom-controls">
            <label class="zoom-label">Zoom</label>
            <input
              class="zoom-slider"
              type="range"
              min="0.5"
              max="10"
              step="0.1"
              value="1"
              [(ngModel)]="image2Zoom"
              (input)="onZoomChange(2, $event)">
            <span class="zoom-value">{{ image2Zoom }}x</span>
          </div>
          <div class="button-group">
            <!-- Face enhance temporarily disabled
            <button class="enhance-btn" (click)="onEnhance(2)">
              Enhance
            </button>
            -->
            <button class="reset-btn" (click)="onReset(2)">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="action-buttons" *ngIf="!isStaleResult">
      <button
        class="action-button split-faces"
        (click)="splitFaces()"
      >
        <i class="bi bi-layout-split action-icon"></i>
        <span>Split Faces</span>
      </button>
      <button
        class="action-button compare-faces"
        (click)="compareFaces()"
      >
        <i class="bi bi-people action-icon"></i>
        <span>Compare Faces</span>
      </button>
    </div>

    <div class="faces-detected" *ngIf="!isStaleResult">
      <div class="faces-comparison">
        <div class="face-section">
          <div class="face-header">
            <h4 class="face-title">Faces in {{ selectedImages[0]?.name || 'Image 1' }}</h4>
            <span class="face-count">{{ getFacesForImage(0).length }} face(s)</span>
          </div>

          <div class="faces-container">
            <div
              class="face-item"
              *ngFor="let face of getFacesForImage(0); let i = index"
              [class.selected]="isFaceSelected(face)"
              (click)="onFaceClick(face)"
            >
              <div class="face-image-container">
                <img class="face-image" [src]="getFaceImage(0, face)" [alt]="'Face ' + (i + 1)">
                <div class="tick-mark" *ngIf="isFaceSelected(face)">
                  <i class="bi bi-check-circle-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="face-section">
          <div class="face-header">
            <h4 class="face-title">Faces in {{ selectedImages[1]?.name || 'Image 2' }}</h4>
            <span class="face-count">{{ getFacesForImage(1).length }} face(s)</span>
          </div>

          <div class="faces-container">
            <div
              class="face-item"
              *ngFor="let face of getFacesForImage(1); let i = index"
              [class.selected]="isFaceSelected(face)"
              (click)="onFaceClick(face)"
            >
              <div class="face-image-container">
                <img class="face-image" [src]="getFaceImage(1, face)" [alt]="'Face ' + (i + 1)">
                <div class="tick-mark" *ngIf="isFaceSelected(face)">
                  <i class="bi bi-check-circle-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="comparison-results" *ngIf="comparisonResults">
      <div class="results-content">
        <div class="results-table-container">
          <table class="comparison-table">
            <tbody>
              <tr class="result-row" *ngFor="let result of comparisonResults.results; let i = index">
                <td class="query-face-cell">
                  <div class="query-face-image-container">
                    <img
                      class="query-face-image"
                      [src]="getFaceImageById(result.query.image_id, result.query.face_id)"
                      [alt]="'Query Face ' + (i + 1)"
                    >
                  </div>
                </td>
                <td class="matches-and-details-cell">
                  <div class="matches-and-details-container">
                    <div
                      class="match-with-details"
                      *ngFor="let match of result.matches; let j = index"
                      [class.match-true]="match.match"
                      [class.match-false]="!match.match"
                    >
                      <div class="match-section">
                        <img
                          class="match-face-image"
                          [src]="getFaceImageById(match.image_id, match.face_id)"
                          [alt]="'Match ' + (j + 1)"
                        >
                      </div>
                      <div class="details-section">
                        <div class="detail-row">
                          <span class="detail-label">Probability</span>
                          <span class="detail-value probability">{{ (match.score * 100).toFixed(1) }}%</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Match</span>
                          <span class="detail-value match-status" [class.match-true]="match.match" [class.match-false]="!match.match">
                            {{ match.match ? 'Yes' : 'No' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="notes-section" *ngIf="faceCompareId && comparisonResults">
      <div class="notes-header">Add Notes</div>
      <div class="notes-content">
        <textarea
          class="note-input"
          [attr.maxlength]="notesMaxLength"
          placeholder="Notes"
          [(ngModel)]="notes"
        ></textarea>
        <div class="notes-footer">
          <span class="character-count">{{ notes.length }}/{{ notesMaxLength }}</span>
          <button
            type="button"
            class="update-button"
            [disabled]="isUpdatingNotes"
            (click)="onUpdateNotesButtonClick()">
            {{ isUpdatingNotes ? 'Updating…' : 'Update Notes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
